(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart-modal')) {
    class SizeChartModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-size-chart-open]');
        if (!this.dialog || !this.trigger) return;

        // showModal() renders in the top layer, so sticky/overflow parents can't clip it.
        this.portal = this.dialog;

        this.onOpen = () => this.open();
        this.onClick = (event) => this.handleClick(event);
        this.onVariant = (event) => this.highlightFromEvent(event);

        this.trigger.addEventListener('click', this.onOpen);
        this.portal.addEventListener('click', this.onClick);
        document.addEventListener('variant:update', this.onVariant);

        try {
          const saved = localStorage.getItem('pawsh-size-unit');
          if (saved === 'cm' || saved === 'in') this.setUnit(saved);
        } catch (e) {}
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onOpen);
        document.removeEventListener('variant:update', this.onVariant);
      }

      open() {
        this.highlightFromPage();
        this.portal.showModal();
      }

      close() {
        this.portal.close();
        this.trigger.focus();
      }

      handleClick(event) {
        if (event.target === this.portal) return this.close(); // backdrop click
        if (event.target.closest('[data-size-chart-close]')) return this.close();
        const unitBtn = event.target.closest('[data-unit-set]');
        if (unitBtn) this.setUnit(unitBtn.dataset.unitSet);
      }

      setUnit(unit) {
        this.portal.dataset.unit = unit;
        this.portal.querySelectorAll('[data-unit-set]').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(btn.dataset.unitSet === unit));
        });
        try { localStorage.setItem('pawsh-size-unit', unit); } catch (e) {}
      }

      // Highlight the row matching the size currently selected on the product page.
      highlightFromPage() {
        const scope = this.closest('product-information, .product-information, main') || document;
        const checked = scope.querySelector('variant-picker input[type="radio"]:checked, variant-picker select option:checked');
        if (checked) this.highlight(checked.value);
      }

      highlightFromEvent(event) {
        const title = event?.detail?.resource?.title || event?.detail?.variant?.title;
        if (title) this.highlight(title);
      }

      highlight(value) {
        const v = String(value).trim().toLowerCase();
        this.portal.querySelectorAll('[data-size-row]').forEach((row) => {
          const match = row.dataset.sizeRow === v || row.dataset.oldSize === v;
          row.classList.toggle('is-current', match);
        });
      }
    }

    customElements.define('size-chart-modal', SizeChartModal);
  }
  } catch(e) { console.error(e); }
})();

})();
